import { Box, Button, Divider, Typography, useTheme } from "@mui/material";
import React from "react";

import FilterBadge from "components/pages/dashboard/surgery_types_procedures/filter/cards/FilterBadge";
import FilterCard from "components/pages/dashboard/surgery_types_procedures/filter/cards/FilterCard";
import NumberStepper from "components/pages/dashboard/surgery_types_procedures/filter/cards/NumberStepper";
import PresetButtons from "components/pages/dashboard/surgery_types_procedures/filter/cards/PresetButtons";
import useRangeFilter from "components/pages/dashboard/surgery_types_procedures/filter/cards/useRangeFilter";

const SectionHeader = ({ title, action }) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      mb: 1,
    }}
  >
    <Typography variant="body2" sx={{ fontWeight: 500 }}>
      {title}
    </Typography>
    {action}
  </Box>
);

const RangeFilterCard = ({ filter }) => {
  const theme = useTheme();
  const {
    value,
    step,
    unit,
    badgeText,
    isEmpty,
    presets,
    presetsTitle,
    applyPreset,
    startBounds,
    endBounds,
    setStart,
    setEnd,
    reset,
  } = useRangeFilter(filter);
  const [start, end] = value;
  const unitLabel = unit.trim();
  const stepUnit =
    step === 1 && filter.unitSingular ? filter.unitSingular : unit;

  return (
    <FilterCard
      title={filter.label}
      description={filter.description}
      badge={<FilterBadge muted={isEmpty}>{badgeText}</FilterBadge>}
    >
      {presets.length > 0 && (
        <>
          <SectionHeader
            title={presetsTitle}
            action={
              <Typography
                variant="caption"
                sx={{ color: theme.palette.lightText.main }}
              >
                Select preset
              </Typography>
            }
          />
          <PresetButtons
            presets={presets}
            value={value}
            onSelect={applyPreset}
          />
          <Divider sx={{ my: 2 }} />
        </>
      )}
      <SectionHeader
        title="Precision Range Limits"
        action={
          <Button
            size="small"
            color="secondary"
            onClick={reset}
            disabled={isEmpty}
            sx={{ textTransform: "none", minWidth: 0, p: 0 }}
          >
            Reset Custom
          </Button>
        }
      />
      <Box sx={{ display: "flex", gap: 1.5 }}>
        <NumberStepper
          label={["Min", unitLabel].filter(Boolean).join(" ")}
          value={start}
          min={startBounds.min}
          max={startBounds.max}
          step={step}
          seed={filter.min}
          onChange={setStart}
        />
        <NumberStepper
          label={["Max", unitLabel].filter(Boolean).join(" ")}
          value={end}
          min={endBounds.min}
          max={endBounds.max}
          step={step}
          seed={filter.max}
          onChange={setEnd}
        />
      </Box>
      <Typography
        variant="caption"
        sx={{ display: "block", mt: 1, color: theme.palette.lightText.main }}
      >
        {`Step size: ${step}${stepUnit}`}
      </Typography>
    </FilterCard>
  );
};

export default RangeFilterCard;
